import { darken } from 'polished';
import styled from 'styled-components';

export const PreviewArea = styled.div`
    border: 2px solid #999;
    padding: 10px;
    width: 100%;
`;

export const ParameterArea = styled.div`
    width: 100%;
    border: 1px solid #ddd;
    padding: 10px;
`;

export const MediaArea = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 10px 0px;
    height: 100%;

    .img-card {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #000;

        img {
            max-height: 30vh;
            max-width: 100%;
            object-fit: contain;
        }
    }
`;

export const Screen = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    border: 2px solid #999;
    width: 100%;
    height: ${props => {
        const w = props.dimensions.width;
        const h = (9.0 / 16.0) * w;
        return `${parseInt(h, 10) || 0}px`;
    }};

    background: ${props => {
        const { colors } = props;
        const c1 = colors && colors.top ? colors.top : '#000';
        const c2 = colors && colors.bottom ? colors.bottom : '#000';

        return `linear-gradient(180deg, ${c1}, ${c2})`;
    }};

    font-family: 'Saira Semi Condensed', sans-serif !important;
    color: #eee;

    button {
        background-color: ${props => {
            const { colors } = props;
            const c = colors && colors.buttons ? colors.buttons : '#000';
            return c;
        }};
    }

    .MuiButton-containedPrimary:hover {
        background-color: ${props => {
            const { colors } = props;
            const c = colors && colors.buttons ? colors.buttons : '#000';

            return darken(0.25, c);
        }};
    }
`;

export const RobotPlaceholder = styled.div`
    height: 80%;
    width: 100%;
    background: #666;
    border: 1px solid #000;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const AppHeader = styled.div`
    width: 100%;
    height: 8%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #000;

    .header-center {
        width: 40%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-image: linear-gradient(
                to top right,
                transparent 50%,
                black 50%
            ),
            linear-gradient(to top left, transparent 50%, black 50%),
            linear-gradient(to right, black, black);
        background-repeat: no-repeat;
        background-size: 25px 100%, 25px 100%, calc(100% - 50px) 100%;
        background-position: 0 0, 100% 0, 25px 0;

        .pluginbot-logo {
            max-height: 50%;
        }
`;

export const AppContent = styled.div`
    width: 100%;
    height: 92%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
`;
